/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon_service_alarm': {
    width: 19,
    height: 21,
    viewBox: '0 0 19 21',
    data: '<defs><path pid="0" d="M19 15h2v3H2v-3h2V8.5a7.5 7.5 0 0 1 15 0V15zM7 15h9V8.5a4.5 4.5 0 1 0-9 0V15zm4.5 7a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" id="svgicon_icon_service_alarm_a"/></defs><g transform="translate(-2 -1)" _fill="none" fill-rule="evenodd"><mask id="svgicon_icon_service_alarm_b" _fill="#fff"><use xlink:href="#svgicon_icon_service_alarm_a"/></mask><use _fill="#000" xlink:href="#svgicon_icon_service_alarm_a"/><g mask="url(#svgicon_icon_service_alarm_b)" _fill="#FF7B49"><path pid="1" d="M0 0h24v24H0z"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/components/icons/icon_service_alarm.js